/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/AIMedicalVisit.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   AI Medical Visit redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Thursday, June 22, 2023 - 12:05 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/06/22  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transcription: "",
  transcriptionArray: [],
  error: null,
};

const updateFieldReducer = (state, action, field) => {
  if (action.payload !== null) {
    state[field] = action.payload[field];
    state.error = null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

const updateFieldArray = (state, action, field) => {
  if (action.payload !== null) {
    state[field] = [...state[field], action.payload];
    state.error = null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

const clearFieldArray = (state, action, field) => {
  state[field] = [];
  state.error = null;
};

export const aiMedicalVisitSlice = createSlice({
  name: "aiMedicalVisit",
  initialState,
  reducers: {
    updateTranscription: (state, action) => updateFieldReducer(state, action, "transcription"),
    updateTranscriptionArray: (state, action) => updateFieldArray(state, action, "transcriptionArray"),
    clearTranscriptionArray: (state, action) => clearFieldArray(state, action, "transcriptionArray"),
    replaceTranscriptionArrayItem: (state, action) => {
      const { i, text } = action.payload;
      if (state.transcriptionArray[i]) {
        state.transcriptionArray = state.transcriptionArray.map((item, index) => (index === i ? { text } : item));
        state.error = null;
      } else {
        state.error = `No item at index ${i} to replace.`;
      }
    },
    replaceWordTokenArrayItem: (state, action) => {
      const { i, transcriptWordList } = action.payload;
      if (state.wordTokenArray[i]) {
        state.wordTokenArray = state.wordTokenArray.map((item, index) =>
          index === i ? { startTime: 1.0, wordTokens: transcriptWordList } : item,
        );
        state.error = null;
      } else {
        state.error = `No item at index ${i} to replace.`;
      }
    },
  },
});

export const { updateTranscription, updateTranscriptionArray, clearTranscriptionArray, replaceTranscriptionArrayItem } =
  aiMedicalVisitSlice.actions;

export default aiMedicalVisitSlice.reducer;
